import i18n, { use, changeLanguage } from 'i18next'
import { initReactI18next } from 'react-i18next'

export const SUPPORTED_LANGUAGES: ReadonlyArray<string> = ['en', 'fr']
export const DEFAULT_LANGUAGE = 'en'

export const normalizeLocale = (locale: string): string =>
  locale.split('-')[0].toLowerCase()

export const detectBrowserLanguage = (): string | undefined => {
  if (typeof window === 'undefined') return undefined

  const browserLocales = navigator.languages ?? [navigator.language]

  for (const locale of browserLocales) {
    const normalized = normalizeLocale(locale)
    if (SUPPORTED_LANGUAGES.includes(normalized)) {
      return normalized
    }
  }

  return undefined
}

export const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('i18nextLng')
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored
    }
  }

  return detectBrowserLanguage() ?? DEFAULT_LANGUAGE
}

use(initReactI18next).init({
  resources: {
    en: {
      common: require('~/locales/en/common.json'),
      auth: require('~/locales/en/auth.json'),
      operational: require('~/locales/en/operational.json'),
      rydershare: require('~/locales/en/rydershare.json'),
      tracking: require('~/locales/en/tracking.json'),
      settings: require('~/locales/en/settings.json'),
    },
    fr: {
      common: require('~/locales/fr/common.json'),
      auth: require('~/locales/fr/auth.json'),
      operational: require('~/locales/fr/operational.json'),
      rydershare: require('~/locales/fr/rydershare.json'),
      tracking: require('~/locales/fr/tracking.json'),
      settings: require('~/locales/fr/settings.json'),
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'auth', 'operational', 'rydershare', 'tracking', 'settings'],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

i18n.on('languageChanged', (lng: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('i18nextLng', lng)
  }
})

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (
      event.key === 'i18nextLng' &&
      event.newValue &&
      SUPPORTED_LANGUAGES.includes(event.newValue) &&
      event.newValue !== i18n.language
    ) {
      changeLanguage(event.newValue)
    }
  })
}

export default i18n
